import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';


import { process } from '@progress/kendo-data-query';
import { EIPGeneralCartModule } from 'eipgeneral-cart';
import { EIPMultiSelectAutoCompleteComponent } from 'eipmulti-select-auto-complete';
import { groupBy, values } from 'lodash';
import { CommonService } from 'src/app/Service/Common.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { MemberElementDetailLinkService } from 'src/app/Service/member-element-detail-link/member-element-detail-link.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { ElementsService } from 'src/app/Service/elements/elements.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-member-element-detail-link',
	templateUrl: './member-element-detail-link.component.html',
	styleUrls: ['./member-element-detail-link.component.css']
})
export class MemberElementDetailLinkComponent implements OnInit, OnDestroy {
	public projectId: number;
	cartRequest = {};
	businessGrpList: BusinessGroupModel[] = [];
	businessGrpId: number | null | undefined;
	disciplineList: any | RoleFeatureModel[] = [];
	disciplineId: number | null | undefined;
	remarks = "";
	projectMembers: any | ProjectMemberModel[] | undefined;
	projectSelectedMembers: ProjectMemberModel[] = [];
	cartDataSource: any[] = [];
	cartSelectedData: any = [];
	cartSelectedDataCopy = [];
	elementId: number | null | undefined;
	elementDetailedId: string | null | undefined;
	elementDedIdCount: number;
	clearElementDD: boolean = true;
	ClearElementDD: string = 'N';
	dedDescription: any;
	disciplineClearDD = 'N';
	setClick: boolean = true;
	fakeCheckAll: boolean | undefined;
	public postMember: any[] = [];
	selectionAction: any[] = [];
	inactiveMemberIds: any[] = [];
	NewMemberSelect: any[] = [];
	removedMember: any[] = [];
	allRowsSelected: boolean = false;
	allRowsLeftSelected: boolean = false;
	enableFilter: boolean = true;
	FilterDataRSList: any[] = []
	FilterDataLSList: any[] = [];
	public skip: number = 20;
	public isEmitOnSelect: string = "N";
	myfilter: any;

	moduleList: any[] = [];
	elementList: any[] = [];
	elemenetDedList: any[] = [];
	selectedBusinessId: number;
	selectedModule: any;
	selectedModuleIds: string;
	selectedModuleCount: number = 0;
	selectedEle_De_desc: string;
	selectedEle_De_Id: number;
	selectedEle_Ded_desc: string;
	selectedEle_Ded_Id: number;
	UnsubscribeArray: Subscription[] = [];


	@ViewChild('CheckTest') select: any | EIPMultiSelectAutoCompleteComponent;
	@ViewChild('card') card: EIPGeneralCartModule | undefined;
	@ViewChild('grid') grid: GridComponent | undefined;
	@ViewChild(DataBindingDirective) directive: any;
	@ViewChild('searchLeftName') inputLeftName: any;
	@ViewChild('searchRightName') inputRightName: any;


	constructor(public organizationService: OrganizationService,
		public commonService: CommonService,
		public notificationService: NotificationService,
		public mapRoleFeatureService: MapRoleFeatureService,
		public memberElementDetailLinkService: MemberElementDetailLinkService,
		public elementLinkService: ElementLinkService,
		public elementService: ElementsService,
	) { }

	ngOnInit() {
		this.projectId = this.commonService.getProjectId();
		let getbusiness = this.commonService.selectedProjectId.subscribe((data: any) => {
			if (data) {
				this.getBusinessGroup(data);
			}
		});
		this.UnsubscribeArray.push(getbusiness);
	}

	/**
	 * Get business group list  
	 * @param projectId 
	 */
	async getBusinessGroup(projectId: number) {
		let response: any = await this.mapRoleFeatureService.getBusinessGroups(projectId).toPromise();
		this.businessGrpList = response.filter((each: any) => each.is_Active);
	}

	async onchangeBusinessGroup(event) {
		this.businessGrpId = Number(event.value);
		this.getModuleList(this.businessGrpId);
	}
	async getModuleList(businessGroupId: number) {
		this.moduleList = await this.elementLinkService.getModuleList(businessGroupId).toPromise();
		this.moduleList = this.moduleList.filter(x => x.cedDescription == "Upload Document" || x.cedDescription == "Schedule Document");
	}
	async onchangeModule(event: any) {
		let selectedModule: number[] = event.emittingList.map(x => x.value);
		if (selectedModule && selectedModule.length > 0) {
			this.elementList = [];
			this.disciplineList = [];
			this.tempdiscipline = [];
			this.cartSelectedData = [];
			this.elementDedIdCount = 0;
			this.selectedModuleCount = selectedModule.length;
			this.selectedModuleIds = selectedModule.toString();
			this.elementList = await this.elementLinkService.getModuleElements(this.projectId, this.businessGrpId, this.selectedModuleIds, this.selectedModuleCount).toPromise();
		}
		else {
			this.selectedModuleCount = 0;
			this.selectedModuleIds = null;
			this.elementList = [];
			this.disciplineList = [];
			this.tempdiscipline = [];
			this.elementDedIdCount = 0;
			this.cartDataSource = [];
			this.projectSelectedMembers = [];
			this.cartSelectedData = [];
		}
	}
	tempdiscipline: any[] = [];
	async onchangeElement(event) {
		this.disciplineList = [];
		this.tempdiscipline = [];
		this.selectedEle_De_desc = event.desc;
		this.elementId = event.value;
		this.disciplineList = await this.mapRoleFeatureService.getDedAgainstDe(this.selectedEle_De_desc, this.businessGrpId, this.selectedModuleIds, null, 0).toPromise();
		this.disciplineList.forEach(eachData => {
			if (!this.tempdiscipline || !this.tempdiscipline.some(x => x.value == eachData.dedId && x.text ==
				(eachData.dedShortDescription ? eachData.dedShortDescription + ' - ' : '') + eachData.dedDescription)) {
				this.tempdiscipline.push({ value: eachData.dedId, text: (eachData.dedShortDescription ? eachData.dedShortDescription + ' - ' : '') + eachData.dedDescription, orderBy: eachData.sortBy });
			}
		});
		this.disciplineList = this.tempdiscipline;
	}
	async onchangeEleDetail(event) {
		let selectedDEDIds: number[] = event.emittingList.map(x => x.value);
		if (selectedDEDIds && selectedDEDIds.length > 0) {
			this.cartSelectedData = [];
			this.elementDedIdCount = selectedDEDIds.length;
			this.elementDetailedId = selectedDEDIds.toString();
			this.projectMembers = await this.memberElementDetailLinkService.getMembers(this.businessGrpId, this.commonService.getProjectId()).toPromise();
			this.setCartValues();
			this.callApis();
		}
		else {
			this.elementDedIdCount = 0;
			this.projectMembers = [];
			this.cartDataSource = [];
			this.projectSelectedMembers = [];
			this.cartSelectedData = [];
		}
	}

	onSelectionChangeRightSide(event: any): void {
		if (event['selectedRows'].length > 0) {
			event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
				element.dataItem.isSelected = true;
				this.selectionAction.push(element.dataItem);
			});
		}
		if (event['deselectedRows'].length > 0) {
			event['deselectedRows'].forEach((element: { dataItem: { isSelected: boolean; value: any; }; }) => {
				element.dataItem.isSelected = false;
				for (let i = 0; i < this.selectionAction.length; i++) {
					if (element.dataItem.value == this.selectionAction[i].value) {
						this.selectionAction.splice(i, 1);
					}
				}
			});
		}
	}

	onSelectionChangeLeftSide(event: any) {
		if (event['selectedRows'].length > 0) {
			event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
				element.dataItem.isSelected = true;
				this.inactiveMemberIds.push(element.dataItem);
			});
		}
		if (event['deselectedRows'].length > 0) {
			event['deselectedRows'].forEach((element: { dataItem: { isSelected: boolean; value: any; }; }) => {
				element.dataItem.isSelected = false;
				for (let i = 0; i < this.inactiveMemberIds.length; i++) {
					if (element.dataItem.value == this.inactiveMemberIds[i].value) {
						this.inactiveMemberIds.splice(i, 1);
					}
				}
			});
		}
	}



	async callApis() {
		// this.projectMembers = await this.memberElementDetailLinkService.getMembers(this.businessGrpId, this.commonService.getProjectId()).toPromise();			
		this.removedMember = [];
		this.inactiveMemberIds = [];
		this.projectSelectedMembers = [];
		this.cartSelectedData = [];
		if (this.businessGrpId)
			this.projectSelectedMembers = await this.memberElementDetailLinkService.getSelectedElementMembers(this.commonService.getProjectId(), this.businessGrpId, this.elementId, this.elementDetailedId, this.elementDedIdCount, this.selectedModuleIds, this.selectedModuleCount).toPromise();
		this.projectSelectedMembers.forEach((eachMember, index) => {
			let cartValue: any = this.getAsCartSelectedValue(eachMember.memberId, eachMember.memberName);
			cartValue["itemIndex"] = index;
			cartValue["isCheck"] = false;
			cartValue["isCheckAll"] = false;
			this.cartSelectedData.push(cartValue);
		});
		this.FilterDataLSList = this.cartSelectedData;
		this.setCartValues();
	}

	/**
	 * Set cart values
	 * Remove selected cart list from original carts list
	 */
	OnClickRightSideHeaderCheckbox(event: any, dataItem: any) {
		if (event.currentTarget.checked) {
			this.selectionAction = [];
			this.cartDataSource.forEach(member => {
				member.isCheck = true
			})
			this.selectionAction = this.cartDataSource;
		} else {
			this.selectionAction = [];
			this.cartDataSource.forEach(member => {
				member.isCheck = false;
			})
		}
	}

	rightcellClickHandler(event: any) {
		let duplicateSelect: boolean = false;
		this.myfilter = true;
		if (this.selectionAction.length > 0) {
			this.selectionAction.forEach(data => {
				if (data.value == event.dataItem.value) {
					data.isCheck = !data.isCheck;
					duplicateSelect = true;
				}
			})
			if (duplicateSelect == false) {
				event.dataItem.isCheck = true;
				this.selectionAction.push(event.dataItem)
			}
		} else {
			event.dataItem.isCheck = true;
			this.selectionAction.push(event.dataItem);
		}
	}

	leftSidecellClickHandler(event: any) {
		let duplicateSelect: boolean = false;
		if (this.inactiveMemberIds.length > 0) {
			this.inactiveMemberIds.forEach(data => {
				if (data.value == event.dataItem.value) {
					data.isCheck = !data.isCheck;
					duplicateSelect = true;
				}
			})
			if (duplicateSelect == false) {
				event.dataItem.isCheck = true;
				this.inactiveMemberIds.push(event.dataItem)
			}
		} else {
			event.dataItem.isCheck = true;
			this.inactiveMemberIds.push(event.dataItem);
		}
	}

	OnClickRightSideRowCheckbox(event: any, dataItem: any) {
		if (event.currentTarget.checked) {
			let duplicateSelect: boolean = false;
			if (this.selectionAction.length > 0) {
				this.selectionAction.forEach(data => {
					if (data.value == dataItem.value) {
						data.isCheck = true;
						duplicateSelect = true;
					}
				})
				if (duplicateSelect == false) {
					dataItem.isCheck = true;
					this.selectionAction.push(dataItem)
				}
			} else {
				dataItem.isCheck = true;
				this.selectionAction.push(dataItem);
			}
		} else {
			this.selectionAction.forEach(data => {
				if (data.value == dataItem.value) {
					data.isCheck = false;
				}
			})
		}
	}

	OnClickLeftSideHeaderCheckbox(event: any, dataItem: any) {
		if (event.currentTarget.checked) {
			this.inactiveMemberIds = [];
			this.cartSelectedData.forEach((member: any) => {
				member.isCheck = true
			})
			this.inactiveMemberIds = this.cartSelectedData;
		} else {
			this.inactiveMemberIds = [];
			this.cartSelectedData.forEach((member: any) => {
				member.isCheck = false;
			})
		}
	}

	public onFilterRS(inputValue: string): void {
		this.cartDataSource = process(this.FilterDataRSList, {
			filter: {
				logic: "or",
				filters: [
					{
						field: 'text',
						operator: 'contains',
						value: inputValue
					}
				],
			}
		}).data;
		this.directive.skip = 0;
	}

	public onFilterLS(inputValue: string): void {
		this.cartSelectedData = process(this.FilterDataLSList, {
			filter: {
				logic: "or",
				filters: [
					{
						field: 'text',
						operator: 'contains',
						value: inputValue
					}
				],
			}
		}).data;
		this.directive.skip = 0;
	}

	OnClickLeftSideRowCheckbox(event: any, dataItem: any) {
		if (event.currentTarget.checked) {
			let duplicateSelect: boolean = false;
			if (this.inactiveMemberIds.length > 0) {
				this.inactiveMemberIds.forEach(data => {
					if (data.value == dataItem.value) {
						data.isCheck = true;
						duplicateSelect = true;
					}
				})
				if (duplicateSelect == false) {
					dataItem.isCheck = true;
					this.inactiveMemberIds.push(dataItem)
				}
			} else {
				dataItem.isCheck = true;
				this.inactiveMemberIds.push(dataItem);
			}
		} else {
			this.inactiveMemberIds.forEach(data => {
				if (data.value == dataItem.value) {
					data.isCheck = false;
				}
			})
		}
	}

	setCartValues() {
		const arr: any = this.projectMembers;
		const ids: any = this.projectMembers.map((o: { memberId: any; }) => o.memberId);
		const filtered = arr.filter(({ memberId }: any, index: number) => !ids.includes(memberId, index + 1));
		if (filtered.length > 0) {
			filtered.forEach((eachMember: { memberId: string | number; memberName: string; }, index: any) => {
				let cartValue: any = this.getAsCartSelectedValue(eachMember.memberId, eachMember.memberName);
				cartValue["itemIndex"] = index;
				cartValue["isCheck"] = false;
				cartValue["isCheckAll"] = false;
				this.cartDataSource.push(cartValue);
				this.cartDataSource = this.getUnique(this.cartDataSource, 'text')
			});
			this.FilterDataRSList = this.cartDataSource;
		}
	}


	getUnique(arr: any[], comp: string) {
		// store the comparison  values in array
		const unique = arr.map(e => e[comp])
			// store the indexes of the unique objects
			.map((e: any, i, final) => final.indexOf(e) === i && i)
			// eliminate the false indexes & return unique objects
			.filter((e: any) => arr[e]).map((e: any) => arr[e]);
		return unique;
	}
	rightSideMoveMember() {
		this.NewMemberSelect = [];
		if (!this.businessGrpId) {
			this.notificationService.showToast("Select Business Group", "Warning");
			return;
		}

		if (!this.elementId) {
			this.notificationService.showToast("Select Element", "Warning");
			return;
		}

		let uniqMember: any[] = [];
		let selectedMember: any[] = [];
		selectedMember = this.selectionAction.filter(data => data.isCheck == true);
		if (selectedMember.length > 0) {
			selectedMember.forEach((element, index) => {
				this.NewMemberSelect.push(element.value);
			})
		}

		if (this.NewMemberSelect.length > 0) {
			this.saveMemberElementDetailLink();
		}

		if (this.cartSelectedData.length > 0) {
			selectedMember.forEach((obj, index) => {
				let duplicateMember = this.cartSelectedData.some((member: { value: any; }) => member.value == obj.value);
				if (duplicateMember == false) {
					uniqMember.push(obj);
				}
			})
		} else {
			Array.prototype.push.apply(this.cartSelectedData, selectedMember);
		}
		if (uniqMember.length > 0) {
			Array.prototype.push.apply(this.cartSelectedData, uniqMember);
		}
		this.cartSelectedData.forEach((member: { [x: string]: any; }, index: any) => {
			member["itemIndex"] = index;
		})
		if (this.inputLeftName.nativeElement.value == '')
			this.inputLeftName.nativeElement.placeholder = 'Search Member...';
		else
			this.inputLeftName.nativeElement.value = '';

	}




	leftSideMoveMember() {
		if (!this.businessGrpId) {
			this.notificationService.showToast("Select business group", "Warning");
			return;
		}

		if (!this.elementId) {
			this.notificationService.showToast("Select discipline", "Warning");
			return;
		}

		let uniqMember: any[] = [];
		this.removedMember = [];
		let leftSideselectedMember: any[] = [];
		leftSideselectedMember = this.inactiveMemberIds.filter(data => data.isCheck == true);
		if (leftSideselectedMember.length > 0) {
			leftSideselectedMember.forEach((element, index) => {
				this.removedMember.push(element.value);
			})
		}
		if (this.removedMember.length > 0) {
			this.saveMemberElementDetailLink();
		}
		if (this.cartSelectedData.length > 0) {
			leftSideselectedMember.forEach((obj, index) => {
				this.cartSelectedData.forEach((member: { value: any; }, i: any) => {
					if (member.value == obj.value) {
						this.cartSelectedData.splice(i, 1);
					}
				});
			})
		}
		if (this.inputRightName.nativeElement.value == '')
			this.inputRightName.nativeElement.placeholder = 'Search Member...';
		else
			this.inputRightName.nativeElement.value = '';
	}

	activeIds(event: EIPAutoCompleteEventModel<ProjectMemberModel>[]) {
		let selectedIds: any = [];
		event.forEach(eachMember => {
			selectedIds.push(eachMember.value);
		});
		return selectedIds;
	}

	/**
	 * Change data to respective cart selected data format
	 * @param value 
	 * @param text 
	 */
	getAsCartSelectedValue(value: string | number, text: string) {
		value = value.toString().trim();
		text = text.trim();
		let output = {
			value,
			text: value + ' - ' + text
		};
		return output;
	}




	saveMemberElementDetailLink() {
		this.NewMemberSelect.forEach((memberID, i) => {
			let duplicateMemberId = this.removedMember.some(newmemberID => newmemberID == memberID);
			if (duplicateMemberId) {
				this.NewMemberSelect.splice(i, 1);
			}
		})

		let reqData: any = {
			"projectId": this.commonService.getProjectId(),
			"groupId": this.businessGrpId,
			"elementId": this.elementId,
			"elementDetailedId": this.elementDetailedId,
			"activeMemberIds": this.NewMemberSelect.length > 0 ? this.NewMemberSelect.toString() : null,
			"inactiveMemberIds": this.removedMember.length > 0 ? this.removedMember.toString() : null,
			"createdBy": this.commonService.getLoggedInUserId(),
			"module": this.selectedModuleIds
		}

		let postmember = this.memberElementDetailLinkService.postMembersElementDetails(reqData).subscribe(data => {
			this.notificationService.handleResponse(data);
			this.selectionAction = [];
			this.NewMemberSelect = [];
			this.removedMember = [];
			this.inactiveMemberIds = [];
			this.cartDataSource = [];
			this.allRowsSelected = false;
			this.allRowsLeftSelected = false;
			this.cartSelectedData = [];
			this.callApis();
		});
		this.UnsubscribeArray.push(postmember);
	}

	/** 
	 * Compare previous selected cart data input and current selected cart data input to get inactive ids
	 * @param prevSelected 
	 * @param currentSelected 
	 * @returns Ex: ['16345'] 
	 */
	getInactiveIds(prevSelected: any[], currentSelected: string | any[]) {
		let InActiveIds: any[] = [];
		prevSelected.forEach(eachSelected => {
			if (!currentSelected.includes(eachSelected['value'])) {
				InActiveIds.push(eachSelected['value']);
			}
		});
		return InActiveIds;
	}



	/**
	 * Compare two arrays and remove data which presents in second array
	 * @param dataSource Main data array
	 * @param selectedArray selected array. Needs to remove from main data array
	 * @param key value key name
	 */
	removeDuplicates(dataSource: any[], selectedArray: any[], key: string) {
		let filteredArray: any[] = [],
			grpdSelecetedArray = groupBy(selectedArray, key);
		dataSource.forEach((eachData: any) => {
			if (!(grpdSelecetedArray[eachData[key]] && grpdSelecetedArray[eachData[key]].length)) {
				filteredArray.push(eachData);
			}
		});
		return filteredArray;
	}

	ngOnDestroy(): void {
		this.UnsubscribeArray.forEach(x => x.unsubscribe());
	}
}